import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import ShirtsService from "../../services/shirts/shirtsService";
import DialogService from "../Dialog/dialogService";
import NotificationService from "../Notification/notificationService";

export default function ShirtDeleteConfirmModal({
  shirtId,
}: {
  shirtId: number;
}) {
  const { deleteShirt } = ShirtsService();
  const { closeAll } = DialogService();
  const { success, error } = NotificationService();

  const handleDelete = async () => {
    try {
      const result = await deleteShirt(shirtId);
      if (result) {
        success("Shirt deleted successfully!");
      } else {
        error("Error deleting shirt!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      closeAll();
    }
  };

  return (
    <>
      <Box sx={{ marginBottom: "1.5rem" }}>
        <Typography sx={{ fontWeight: 600 }}>
          Are you sure want to delete this shirt?
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", columnGap: 1 }}>
        <Link onClick={closeAll} to={""}>
          <a
            className="default-btn move-right"
            style={{
              width: "120px",
              textAlign: "center",
              padding: "0rem",
            }}
          >
            <span>Cancel</span>
          </a>
        </Link>
        <Link onClick={handleDelete} to={""}>
          <a
            className="default-btn move-right style-2"
            style={{
              width: "120px",
              textAlign: "center",
              padding: "0rem",
            }}
          >
            <span>Delete</span>
          </a>
        </Link>
      </Box>
    </>
  );
}
